module.exports = __webpack_public_path__ + "static/media/Cart_add.7c7bb628.svg";